import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

export const LOGO_URL = '/indivalife-icon.png?v=3';
export const BRAND_NAME = 'INDIVALIFE';
export const BRAND_LEGAL = 'INDIVALIFE Pvt Ltd';
